import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { Topbar } from "@/components/layout/Topbar";
import { findItemByPath } from "@/config/modules";

export function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const item = findItemByPath(location.pathname);
  const title = item?.label || "Dashboard";

  return (
    <div className="flex min-h-screen bg-[#FAF8F5]">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar title={title} />
        <main className="flex-1 overflow-x-hidden p-4 sm:p-6 lg:p-8">
          <div className="mx-auto max-w-[1500px] animate-fade-in-up">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
